'use client'

import { RefObject, useEffect } from 'react'

export function useClickOutsideElement(
  ref: RefObject<any>, // eslint-disable-line @typescript-eslint/no-explicit-any
  callback?: () => void
) {
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (!ref.current?.contains(e.target)) {
        callback?.()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [callback, ref])
}
